import { render, staticRenderFns } from "./DetailNavigation.vue?vue&type=template&id=570ecfa2&scoped=true&"
import script from "./DetailNavigation.vue?vue&type=script&lang=js&"
export * from "./DetailNavigation.vue?vue&type=script&lang=js&"
import style0 from "./DetailNavigation.vue?vue&type=style&index=0&id=570ecfa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570ecfa2",
  null
  
)

component.options.__file = "DetailNavigation.vue"
export default component.exports